<div class="service-list-content service-bg">
    <div class="container">
        <app-company-service-list></app-company-service-list>
    </div>
</div>